// extracted by mini-css-extract-plugin
module.exports = {"name":"ContactItem_name__2E6sD","number":"ContactItem_number__3WqcS"};